/**
 * Modo simulação: login pelo `tokenItem` (botão "Simular" do Studio) grava
 * `readOnly` no localStorage, e o interceptor bloqueia as gravações.
 * Telas que gravam devem avisar com esta mensagem em vez do erro genérico.
 */

/**
 * Únicos sites onde a simulação pode gravar (homologação). Comparação exata:
 * qualquer outro endereço, inclusive produção, fica somente leitura.
 */
const HOSTS_SIMULACAO_COM_GRAVACAO = [
  'premiobb2026-staging.funifier.com',
  'premioelbb-staging.funifier.com',
];

export const MENSAGEM_MODO_SIMULACAO =
  'Você está em modo simulação (somente leitura): não é possível salvar alterações.';

export function isModoSimulacao(): boolean {
  try {
    return Boolean(localStorage.getItem('readOnly'));
  } catch {
    return false;
  }
}

/** Chamado no login pelo `tokenItem`, antes de autenticar. */
export function ativarModoSimulacao(hostname = window.location.hostname): void {
  if (HOSTS_SIMULACAO_COM_GRAVACAO.includes(hostname)) {
    localStorage.removeItem('readOnly');
    return;
  }
  localStorage.setItem('readOnly', 'true');
}
